/* import __COLOCATED_TEMPLATE__ from './transfer-speed-step.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();